import request from '@/utils/request'

/**
 * 自主注册
 * @param {Object} data - 注册数据
 * @param {String} data.username - 用户名
 * @param {String} data.password - 密码
 * @param {Number} data.whetherSubAccount - 是否子账户：0->否；1->是
 * @param {Number} data.telephone - 手机号码
 * @param {Number} data.sourceType - 来源类型：1 自主注册 0 管理员添加
 * @param {String} data.referrer - 推荐人
 * @param {Number} data.status - 账号启用状态：0->禁用；1->启用
 * @returns {Promise}
 */
export function selfRegister(data) {
  return request({
    url: '/admin/selfRegister',
    method: 'post',
    data
  })
}

/**
 * 检查用户名是否存在
 * @param {String} username - 用户名
 * @returns {Promise}
 */
export function checkUsername(username) {
  return request({
    url: '/admin/checkUsername',
    method: 'get',
    params: { username }
  })
}
